import * as tslib_1 from "tslib";
import calendarFolder from 'owa-service/lib/factory/calendarFolder';
import folderChange from 'owa-service/lib/factory/folderChange';
import folderId from 'owa-service/lib/factory/folderId';
import getCalendarSharingCalendars from '../data/selectors/getCalendarSharingCalendars';
import getCalendarSharingCurrentState from '../data/selectors/getCalendarSharingCurrentState';
import getCalendarSharingInitialState from '../data/selectors/getCalendarSharingInitialState';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import saveCalendarSharingConfiguration from '../services/saveCalendarSharingConfiguration';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import { trace } from 'owa-trace';
import updateChangeNotificationStatusInInitialState from '../data/mutators/updateChangeNotificationStatusInInitialState';
/**
 * 1. Gets current state from store selector.
 * 2. Gets list of shared calendars from store selector.
 * 3. Create a folderChange array of changes made to shared calendars.
 * 4. Call saveCalendarSharingConfiguration.
 */
export default function saveSharedCalendarOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentState_1, intialState_1, calendars, promisesArray_1, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    currentState_1 = getCalendarSharingCurrentState();
                    intialState_1 = getCalendarSharingInitialState();
                    calendars = getCalendarSharingCalendars();
                    promisesArray_1 = [];
                    calendars.map(function (calendar) {
                        var changes = [];
                        var currentStatus = currentState_1[calendar.folderId];
                        var intialStatus = intialState_1[calendar.folderId];
                        if (currentStatus != intialStatus) {
                            var updates = [
                                setFolderField({
                                    Path: propertyUri({ FieldURI: 'ChangeNotificationStatus' }),
                                    Folder: calendarFolder({
                                        ChangeNotificationStatus: currentStatus,
                                    }),
                                }),
                            ];
                            changes.push(folderChange({
                                FolderId: folderId({ Id: calendar.folderId }),
                                Updates: updates,
                            }));
                            promisesArray_1.push(saveCalendarSharingConfiguration(changes));
                        }
                    });
                    return [4 /*yield*/, Promise.all(promisesArray_1).then(function (results) {
                            results.map(function (result) {
                                if (result) {
                                    var folderInfoResponseMessage = result.ResponseMessages
                                        .Items[0];
                                    var folderId_1 = folderInfoResponseMessage.Folders[0].FolderId.Id;
                                    updateChangeNotificationStatusInInitialState(folderId_1, currentState_1[folderId_1]);
                                }
                            });
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    trace.warn(e_1.message || 'saveChangeNotificationStatusFlag failed');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveSharedCalendarOption.js.map